export const getCompanyCalibrations = (state, companyId) => state.calibrations.get('calibrations')[companyId] || []
export const isCompanyCalibrationsLoading = (state, companyId) => !!state.calibrations.get('calibrationsIsLoading')[companyId]
export const isAddCalibrationLoading = state => !!state.calibrations.get('addCalibrationLoading')
